module.exports = __webpack_public_path__ + "media/images/suppliers/Invitrogen-723a9dae71fd2cdb40029f956f9afb64.png";